import { Component, Input, SimpleChanges } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  AttachmentTypeIdEnum,
  TenderDocumentAttachment,
} from 'src/app/shared/models/database-models';
import { BackendApiService } from '../../../../core/services/backend-api';

@Component({
  selector: 'app-tender-documents',
  templateUrl: './tender-documents.component.html',
  styleUrls: ['./tender-documents.component.scss'],
})
export class TenderDocumentsComponent {
  @Input() dataAttachment: TenderDocumentAttachment[] = [];
  public AttachmentTypeId = AttachmentTypeIdEnum;
  transformedAttachment: TenderDocumentAttachment[] = [];
  constructor(private backendService: BackendApiService) {}

  async downloadAttactment(attachment: TenderDocumentAttachment) {
    try {
      let data: any = await lastValueFrom(
        this.backendService.downloadAttachment(
          attachment.AttachmentId?.toString() as string
        )
      );
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: `application/json` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = attachment.FileName;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('error downloading');
    }
  }
  ngOnChanges(changes:SimpleChanges){
    if (changes['dataAttachment'].currentValue){
      this.transformedAttachment = this.dataAttachment.sort((a, b) =>
        a.AttachmentTypeId > b.AttachmentTypeId ? 1 : -1
      );
    }
  }
  ngOnInit() {
  }
}
